import { AppStateType, Order } from 'app-core';
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: (): AppStateType => {
    return {
      lastTenant: null,
      tenant: null,
      user: null,
      curOrder: null,
      curUnpaidOrders: [],
      curPayOptions: Order.getPayOptions(),
      cashRegister: null,
      terminal: null,
      pendingCardPayment: null,
      cardSettlement: { lastSettledAt: null, unsettledPayments: false },
      pendingOrderData: null,
      pausedOrderData: null,
      curGuest: 0,
      appConfig: null,
      printConfig: null,
      isOnline: true,
      localConnection: { connected: false, isServer: false, serverAddress: null, serverPort: null, terminals: [] },
      device: null,
      syncStatus: 'done',
      syncOptions: { limit: 50, timeout: 120000, autoSyncDisabled: false },
      workingDays: [],
      impersonate: false,
      trainingMode: false,
      tableMode: null,
      splitReceipt: { active: false, data: [] },
      curPricelist: 0,
      curDiscountPercent: 0,
      modules: {},
      integrations: {},
      ordersHubActive: false,
      locale: 'sr',
      subscriptionExpired: false,
      isRetail: false,
      lockedReason: null,
      kdsSettings: {
        itemsPerPage: [3, 4],
        fontSize: 'medium',
        yellowTimer: 5,
        redTimer: 7,
        filterForUser: false
      },
      activeSector: 0,
      darkTheme: null,
      redirect: false,
      debugMode: false,
      log: []
    }
  },
  getters: {
    /** The theme in effect: the user's own choice once they made one;
     *  until then dark for hospitality, light for retail (owner 2026-10-04).
     *  Read this, not `darkTheme`; a toggle writes `darkTheme` explicitly. */
    isDark(state): boolean {
      return state.darkTheme ?? !state.isRetail
    },
    unpaidOrders(state): Order[] {
      const curUnpaidOrders = state.curUnpaidOrders as Order[]

      if (state.isRetail) return curUnpaidOrders

      return curUnpaidOrders.filter(order => {
        const guestFlag = order.getGuestId() || 0;
        return guestFlag === state.curGuest;
      })
    },
  }
})
